export const projects = [
  {
    id: 1,
    title: "Ashirwada Poojawa",
    date: "July 05, 2025",
    description: "ශ්‍රී ජයවර්ධනපුර විශ්ව විද්‍යාලීය D7 ලියෝවරුන් නව ලියෝ වසරට ආසිරි පතමින් බෙල්ලන්විල රජ මහා විහාරස්ථානයේදී ආශිර්වාදාත්මක බෝධි පූජාමය පින්කමක් සංවිධානය කරමින් නව වසරක සමාරම්භය සනිටුවන් කරන ලදී.",
    status: "Completed",
    images: [
      "/projects/1 Ashirwada Poojawa/1.jpg",
      "/projects/1 Ashirwada Poojawa/2.jpg",
      "/projects/1 Ashirwada Poojawa/3.jpg"
    ]
  },
  {
    id: 2,
    title: "Mehendi & Ice Cream Stall",
    date: "July 25, 2025",
    description: "We organized a vibrant Mehendi stall as part of our fundraising efforts. With the collective support of our energetic members and dedicated project coordinators, the stall was both beautifully presented and smoothly managed.",
    status: "Completed",
    images: [
      "/projects/2 Mehendi & Ice Cream Stall/1.jpg",
      "/projects/2 Mehendi & Ice Cream Stall/2.jpg",
      "/projects/2 Mehendi & Ice Cream Stall/3.jpg"
    ]
  },
  {
    id: 3,
    title: "Leo Tree Plantation Challenge 2025",
    date: "2025",
    description: "With a firm vision for a greener future, the Japura D7 Leos proudly joined hands in Leo Tree Plantation Challenge Season 6 – Phase 1, a remarkable initiative committed to environmental protection and sustainability.",
    status: "Completed",
    impact: "10+ volunteers",
    images: [
      "/projects/3 Leo Tree Plantation Challenge 2025/1.jpg",
      "/projects/3 Leo Tree Plantation Challenge 2025/2.jpg",
      "/projects/3 Leo Tree Plantation Challenge 2025/3.jpg"
    ]
  },
  {
    id: 4,
    title: "Leo Photo Shoot",
    date: "Aug 16, 2025",
    description: "We recently held a memorable photo shoot with the full board of Leo Club officers, bringing together around 54 dedicated members including the executive board, directors, pressure coordinators, and all supporting crews",
    status: "Completed",
    images: [
      "/projects/4 Leo Photo Shoot/1.jpg",
      "/projects/4 Leo Photo Shoot/2.jpg",
      "/projects/4 Leo Photo Shoot/3.jpg"
    ]
  },
  {
    id: 5,
    title: "Scintillate’25",
    date: "Aug 30, 2025",
    description: "The 7th Annual Installation Ceremony of the Leo Club of District 306 D7, University of Sri Jayewardenepura! Successfully concluded at Sumangala Auditorium, University of Sri Jayewardenepura.",
    status: "Completed",
    images: [
      "/projects/5 Scintillate25/1.jpg",
      "/projects/5 Scintillate25/2.jpg",
      "/projects/5 Scintillate25/3.jpg"
    ]
  },
  {
    id: 6,
    title: "A Day of Hope",
    date: "Sep 14, 2025",
    description: "පොර බදන පණ නළට සරණක් අවැසි මොහොතක සවියක් එක් කරන්නට, අත්වැල් පවුරු බැඳ ජීවයේ අපේක්ෂාවන් දල්වන්නට, සැප්තැම්බර් මස 14 දින මහරගම අපේක්ෂා රෝහල් පරිශ්‍රයේදී, මිනිස්කම් පෙරට ගෙන එක්වූ වගයි....",
    status: "Completed",
    impact: "10+ volunteers",
    images: [
      "/projects/6 A Day of Hope/1.jpg",
      "/projects/6 A Day of Hope/2.jpg",
      "/projects/6 A Day of Hope/3.jpg"
    ]
  },
  {
    id: 7,
    title: "Chai Stall",
    date: "Sep 23, 2025",
    description: "Our members and project coordinators worked together to make the stall look stunning and run efficiently. The event garnered a lot of interest and helped us raise a respectable amount of money.",
    status: "Completed",
    images: [
      "/projects/7 Chai Stall/1.jpg",
      "/projects/7 Chai Stall/2.jpg",
      "/projects/7 Chai Stall/3.jpg"
    ]
  },
  {
    id: 8,
    title: "Zero Trash Side",
    date: "Sep 28, 2025",
    description: "Every piece of trash we remove is a promise to the ocean. We're uniting to clean our coastline and protect marine life because a healthy beach means a healthier planet.",
    status: "Completed",
    impact: "10+ bags of trash removed",
    images: [
      "/projects/8 Zero Trash Side/1.jpg",
      "/projects/8 Zero Trash Side/2.jpg",
      "/projects/8 Zero Trash Side/3.jpg"
    ]
  },
  {
    id: 9,
    title: "Rainbow Bloosoms - Phase 01",
    date: "Oct 03, 2025",
    description: "Art for Peace Bringing color, calm, and creativity to young minds! Where little hearts find peace, tiny hands bloom with imagination, and every brushstroke brings a smile.",
    status: "Completed",
    images: [
      "/projects/9 Rainbow Bloosoms - Phase 01/1.jpg",
      "/projects/9 Rainbow Bloosoms - Phase 01/2.jpg",
      "/projects/9 Rainbow Bloosoms - Phase 01/3.jpg"
    ]
  },
  {
    id: 10,
    title: "Lead with Leoism",
    date: "Oct 10, 2025",
    description: "Step into a space where passion meets purpose, where teamwork transforms into growth! Join us for an inspiring afternoon filled with connection, learning, and true essence of Leoism !",
    status: "Completed",
    images: [
      "/projects/11 Lead with Leoism/1.jpg",
      "/projects/11 Lead with Leoism/2.jpg",
      "/projects/11 Lead with Leoism/3.jpg"
    ]
  },
  {
    id: 11,
    title: "Greener Tomorrow",
    date: "Oct 17, 2025",
    description: "A step towards a cleaner, healthier, and more sustainable planet. Together, we plant the seeds of change today for a brighter, greener future.",
    status: "Completed",
    images: [
      "/projects/10 Greener Tomorrow/1.jpg",
      "/projects/10 Greener Tomorrow/2.jpg",
      "/projects/10 Greener Tomorrow/3.jpg"
    ]
  },
  {
    id: 12,
    title: "Rainbow Bloosoms - Phase 02",
    date: "Oct 19, 2025",
    description: "Bringing color, calm, and creativity to young minds! Where little hearts find peace, tiny hands bloom with imagination, and every brushstroke brings a smile.",
    status: "Completed",
    images: [
      "/projects/12 Rainbow Bloosoms - Phase 02/1.jpg",
      "/projects/12 Rainbow Bloosoms - Phase 02/2.jpg",
      "/projects/12 Rainbow Bloosoms - Phase 02/3.jpg"
    ]
  },
  {
    id: 13,
    title: "Guiding Wings - Phase 01",
    date: "Nov 24, 2025",
    description: "We lifted young minds, sparked confidence, and helped dreams take flight. A heartfelt thank you to everyone who made this milestone possible!",
    status: "Completed",
    impact: "20+ volunteers",
    images: [
      "/projects/13 Guiding Wings - Phase 01/1.jpg",
      "/projects/13 Guiding Wings - Phase 01/2.jpeg",
      "/projects/13 Guiding Wings - Phase 01/3.jpeg"
    ]
  },
  {
    id: 14,
    title: "Rainbow Bloosoms - Phase 03",
    date: "Dec 13, 2025",
    description: "Bringing color, calm, and creativity to young minds! Where little hearts find peace, tiny hands bloom with imagination, and every brushstroke brings a smile.",
    status: "Completed",
    images: [
      "/projects/14 Rainbow Bloosoms - Phase 03/1.jpg",
      "/projects/14 Rainbow Bloosoms - Phase 03/2.jpg",
      "/projects/14 Rainbow Bloosoms - Phase 03/3.jpg"
    ]
  },
  {
    id: 15,
    title: "Eco-Kids Challenge - 01",
    date: "Dec 17, 2025",
    description: "A fantastic day of learning, waste segregation, and eco-action! Inspiring to see young leaders embrace sustainability with such passion.",
    status: "Completed",
    images: [
      "/projects/15 Eco-Kids Challenge - 01/1.jpg",
      "/projects/15 Eco-Kids Challenge - 01/2.jpg",
      "/projects/15 Eco-Kids Challenge - 01/3.jpg"
    ]
  },
  {
    id: 16,
    title: "Eco-Kids Challenge - 02",
    date: "Dec 19, 2025",
    description: "Let’s inspire young eco-warriors! Inspiring the next generation to love and protect our planet.",
    status: "Completed",
    images: [
      "/projects/16 Eco-Kids Challenge - 02/1.jpg",
      "/projects/16 Eco-Kids Challenge - 02/2.jpg",
      "/projects/16 Eco-Kids Challenge - 02/3.jpg"
    ]
  },
  {
    id: 17,
    title: "Lead with Leoism - Phase 03",
    date: "Jan 04, 2026",
    description: "Sunshine, shared snacks, and stronger bonds! Lead with Leoism 6.0 – Phase 3 is all about pausing the hustle and celebrating us.",
    status: "Completed",
    impact: "30+ participants",
    images: [
      "/projects/17 Lead with Leoism - Phase 03/1.jpg",
      "/projects/17 Lead with Leoism - Phase 03/2.jpeg",
      "/projects/17 Lead with Leoism - Phase 03/3.jpeg"
    ]
  },
  {
    id: 20,
    title: "Thread to Hope",
    date: "Feb 01, 2026",
    description: "Something meaningful comes together, one stitch at a time. Hands will learn, create, and grow stronger, because every crochet tells a story. ",
    status: "Completed",
    images: [
      "/projects/21 Thread to Hope/1.jpg",
      "/projects/21 Thread to Hope/2.jpg",
      "/projects/21 Thread to Hope/3.jpg"
    ]
  },
  {
    id: 18,
    title: "Little Legends",
    date: "Feb 07, 2026",
    description: "Every child here is a Little Legend-fighting battles with courage, hope, and a beautiful smile. We stand with you, today and always",
    status: "Completed",
    impact: "20+ children impacted",
    images: [
      "/projects/18 Little Legends/1.jpg",
      "/projects/18 Little Legends/2.jpg",
      "/projects/18 Little Legends/3.jpg"
    ]
  },
  {
    id: 19,
    title: "U Turn - Phase 01",
    date: "Feb 16, 2026",
    description: "From awareness to action, Project U-Turn became a meaningful step toward building a safer, drug-free future.",
    status: "Completed",
    impact: "150+ awareness created",
    images: [
      "/projects/19 U Turn - Phase 01/1.jpg",
      "/projects/19 U Turn - Phase 01/2.jpeg",
      "/projects/19 U Turn - Phase 01/3.jpeg"
    ]
  },
  {
    id: 21,
    title: "Bright Hands",
    date: "Feb 28, 2026",
    description: "A small spark can light up more than a room - it can light up a life. Every glow carries confidence, creativity, and courage.",
    status: "Completed",
    images: [
      "/projects/20 Bright Hands/1.jpg",
      "/projects/20 Bright Hands/2.jpg",
      "/projects/20 Bright Hands/3.jpg"
    ]
  },
  {
    id: 22,
    title: "Guardian Roots",
    date: "Feb 28, 2026",
    description: "Join us as we empower young hands to nurture nature and build a sustainable future. Together, let’s grow strong roots for the next generation.",
    status: "Completed",
    impact: "20+ children impacted",
    images: [
      "/projects/22 Guardian Roots/1.jpg",
      "/projects/22 Guardian Roots/2.jpg",
      "/projects/22 Guardian Roots/3.jpg"
    ]
  },
  {
    id: 23,
    title: "Cinema Night",
    date: "March 03, 2026",
    description: "Prepare yourself for a truly magical cinematic experience at the University of Sri Jayewardenepura. Successfully concluded at Munasinghe Hall, FMSC, University of Sri Jayewardenepura.",
    status: "Completed",
    images: [
      "/projects/24 Cinema Night/1.jpg",
      "/projects/24 Cinema Night/2.jpg",
      "/projects/24 Cinema Night/3.jpg"
    ]
  },
  {
    id: 24,
    title: "Echoes of Light",
    date: "March 05, 2026",
    description: "An evening of constellations, curiosity, and cosmic wonder awaits! Join us for a magical night under the stars, where we’ll explore the universe together and let our imaginations soar.",
    status: "Completed",
    impact: "100+ children engaged",
    images: [
      "/projects/23 Echoes of Light/1.jpg",
      "/projects/23 Echoes of Light/2.jpeg",
      "/projects/23 Echoes of Light/3.jpeg"
    ]
  },
  {
    id: 25,
    title: "Reef for future",
    date: "March 08, 2026",
    description: "Heal the reefs. Protect the oceans. Secure the future. Successfully concluded at Rumassala, Galle. Reef for Future — reviving marine life, one reef at a time",
    status: "Completed",
    impact: "20+ volunteers",
    images: [
      "/projects/25 Reef for future/1.jpg",
      "/projects/25 Reef for future/2.jpeg",
      "/projects/25 Reef for future/3.jpeg"
    ]
  },
  {
    id: 26,
    title: "AAYU",
    date: "March 10, 2026",
    description: "Project AAYU - Japura Good Market was successfully carried out with the aim of promoting proper nutrition and better lifestyles.",
    status: "Completed",
    impact: "5+ stalls and 150+ visitors",
    images: [
      "/projects/26 AAYU/1.jpg",
      "/projects/26 AAYU/2.png",
      "/projects/26 AAYU/3.jpg"
    ]
  },
  {
    id: 27,
    title: "Holi Festival",
    date: "March 13, 2026",
    description: "Let’s come together to celebrate the vibrant spirit of Holi, where every splash of color spreads happiness, friendship, and unity! Successfully concluded at University of Sri Jayewardenepura.",
    status: "Completed",
    impact: "250+ participants",
    images: [
      "/projects/27 Holi Festival/1.jpg",
      "/projects/27 Holi Festival/2.jpg",
      "/projects/27 Holi Festival/3.jpg"
    ]
  },
  {
    id: 28,
    title: "ReCreateX",
    date: "March 18, 2026",
    description: "The waste meets creativity and transforms into innovation! Exhibition | Fashion Show. Exciting rewards & certificates for all participants. Successfully concluded at University of Sri Jayewardenepura.",
    status: "Completed",
    images: [
      "/projects/28 ReCreateX/1.jpg",
      "/projects/28 ReCreateX/2.jpg",
      "/projects/28 ReCreateX/3.jpg"
    ]
  },
  {
    id: 29,
    title: "Beyond Barriers",
    date: "March 19, 2026",
    description: "Get ready to step Beyond The Barriers and unlock new possibilities. Successfully concluded at Sucharithodaya Social Services Center, Maharagama. We come together to serve, uplift, and make a meaningful impact in the community.",
    status: "Completed",
    images: [
      "/projects/29 Beyond Barriers/1.jpg",
      "/projects/29 Beyond Barriers/2.jpg",
      "/projects/29 Beyond Barriers/3.jpg"
    ]
  },
  {
    id: 30,
    title: "ShieldUp",
    date: "March 20, 2026",
    description: "Step in. Stand strong. Stay safe! Successfully concluded at Dharmapala College, Erewwala. An inspiring session focused on empowering school children with self-defense skills and promoting personal safety through awareness and action!",
    status: "Completed",
    images: [
      "/projects/30 ShieldUp/1.jpg",
      "/projects/30 ShieldUp/2.jpg",
      "/projects/30 ShieldUp/3.jpg"
    ]
  },
  {
    id: 31,
    title: "Rakawarana",
    date: "March 21, 2026",
    description: "අප වෙනුවෙන් අපරිමිත කැපකිරීම් කළ ඔවුන්ට ආදරයෙන් හා ගෞරවයෙන් පිරුණු හදවතින් ‘රැකවරණ’ ව්‍යාපෘතිය සාර්ථකව නිමාවට පත් විය.",
    status: "Completed",
    images: [
      "/projects/31 Rakawarana/1.jpg",
      "/projects/31 Rakawarana/2.jpeg",
      "/projects/31 Rakawarana/3.jpeg"
    ]
  },
  {
    id: 32,
    title: "Tummy Kins",
    date: "March 26, 2026",
    description: "Building a healthier tomorrow starts with the smallest hands! Join us as fruits become fun and every bite helps little ones grow.",
    status: "Completed",
    images: [
      "/projects/32 Tummy Kins/1.jpg",
      "/projects/32 Tummy Kins/2.jpeg",
      "/projects/32 Tummy Kins/3.jpeg"
    ]
  },
  {
    id: 33,
    title: "Diacare - Phase 01",
    date: "March 27, 2026",
    description: "Empowering young minds with knowledge on diabetes prevention and healthy living through Diacare - Phase 01. Successfully concluded at Delthara Maha Vidyalaya, Piliyandalaya. Let’s build a healthier future together.",
    status: "Completed",
    images: [
      "/projects/33 Diacare - Phase 01/1.jpeg",
      "/projects/33 Diacare - Phase 01/2.jpg",
      "/projects/33 Diacare - Phase 01/3.jpg"
    ]
  },
  {
    id: 34,
    title: "U Turn - Phase 02",
    date: "March 28, 2026",
    description: "One wrong turn… everything changes. This isn’t just a story — it’s a reality happening around us. Be the reason someone takes a U-Turn before it’s too late.",
    status: "Completed",
    impact: "150+ awareness created",
    images: [
      "/projects/34 U Turn - Phase 02/1.jpg",
      "/projects/34 U Turn - Phase 02/2.jpeg",
      "/projects/34 U Turn - Phase 02/3.jpeg"
    ]
  },
  {
    id: 35,
    title: "Healing Hues",
    date: "March 28, 2026",
    description: "Colors of Care for Little Hearts! Spreading joy, comfort, and creativity to young hearts because every child deserves a little color. ",
    status: "Completed",
    images: [
      "/projects/35 Healing Hues/1.jpg",
      "/projects/35 Healing Hues/2.jpg"
    ]
  },
  {
    id: 36,
    title: "Aluth Panthiya",
    date: "April 1, 2026",
    description: "අතහැර දමා තිබූ පංති කාමරය, නව ජීවයකින් පිරිපුන් කරමින්, අලුත් පංතියක් බවට පත් කිරීමට වූ වෑයම මෙසේ සාර්ථකව නිමාවට පත් විය.",
    status: "Completed",
    images: [
      "/projects/37 Aluth Panthiya/1.jpg",
      "/projects/37 Aluth Panthiya/2.jpeg",
      "/projects/37 Aluth Panthiya/3.jpeg"
    ]
  },
  {
    id: 37,
    title: "Prarthana",
    date: "April 4, 2026",
    description: "මහරගම අපේක්ෂා රෝහලේ මල් කැකුළු වෙනුවෙන් සිනාවත්, සතුටත් ගෙන යන්න ජ'පුර ලියෝ අපි සූදානම්. ඔවුන් වෙනුවෙන් ඔබේ ප්‍රාර්ථනාව අවශ්‍ය මොහොතයි මේ...",
    status: "Completed",
    images: [
      "/projects/36 Prarthana/1.jpg",
      "/projects/36 Prarthana/2.jpg",
      "/projects/36 Prarthana/3.jpg"
    ]
  },
  {
    id: 38,
    title: "Future Xperience",
    date: "April 9, 2026",
    description: "Future Xperience – Panel Discussion! Successfully completed... An inspiring and insightful session with leading industry experts, sharing their journeys and perspectives.",
    status: "Completed",
    images: [
      "/projects/38 Future Xperience/1.jpg",
      "/projects/38 Future Xperience/2.jpeg",
      "/projects/38 Future Xperience/3.jpeg"
    ]
  },
  {
    id: 41,
    title: "Salakillen Surakemu",
    date: "April 24, 2026",
    description: "අපරාධ, හදිසි අනතුරු හා ආපදා පිළිබඳ දැනුවත් කිරීමේ වැඩසටහනට ඔබත් එක්වන්න! සුරක්ෂිත සමාජයක් සඳහා ඔබේ සහයෝගය ලබාදෙන්න.",
    status: "Completed",
    images: [
      "/projects/41 Salakillen Surakemu/1.jpg",
      "/projects/41 Salakillen Surakemu/2.jpeg",
      "/projects/41 Salakillen Surakemu/3.jpeg"
    ]
  },
  {
    id: 39,
    title: "E School",
    date: "April 28, 2026",
    description: "Empowering young minds through technology, innovation, and knowledge sharing. Successfully concluded at Delthara Maha Vidyalaya, Piliyandalaya. Together, we’re building a brighter future for education.",
    status: "Completed",
    images: [
      "/projects/39 E School/1.jpg",
      "/projects/39 E School/2.jpg"
    ]
  },
  {
    id: 40,
    title: "Nethra",
    date: "April 29, 2026",
    description: "ශ්‍රී ජයවර්ධනපුර විශ්වවිද්‍යාලයීය දිස්ත්‍රික් 306 D7 ලියෝ අප විසින් සංවිධානය කරන ලද 'නේත්‍රා’ ව්‍යාපෘතිය ගම්පහ පීටර් වීරසේකර ළමා නිවාසයේ දී පැවත්විය.",
    status: "Completed",
    images: [
      "/projects/40 Nethra/1.png",
      "/projects/40 Nethra/2.jpeg",
      "/projects/40 Nethra/3.jpeg"
    ]
  },
  {
    id: 42,
    title: "Inkspire",
    date: "April 29, 2026",
    description: "INKSPIRE – ART & PHOTOGRAPHY COMPETITION!",
    status: "Completed",
    images: [
      "/projects/42 Inkspire/1.jpg",
      "/projects/42 Inkspire/2.jpg",
      "/projects/42 Inkspire/3.jpg"
    ]
  },
  {
    id: 43,
    title: "Thirst to Thrive",
    date: "April 30, 2026",
    description: "'This is where change begins, quietly & meaningfully' a reminder that every early step holds the power to create lasting impact.",
    status: "Completed",
    images: [
      "/projects/43 Thirst to Thrive/1.jpg",
      "/projects/43 Thirst to Thrive/2.jpg",
      "/projects/43 Thirst to Thrive/3.jpg"
    ]
  },
  {
    id: 44,
    title: "Senehase Athwala",
    date: "July 17, 2026",
    description: "'Senehase Athwala was conducted at the Geriatric and Palliative Care Unit of Colombo South Teaching Hospital, Kalubowila, to promote the mental, cognitive, physical, and social wellbeing of senior citizens.",
    status: "Completed",
    images: [
      "/projects/44 Senehase Athwala/1.jpeg",
      "/projects/44 Senehase Athwala/2.jpeg",
      "/projects/44 Senehase Athwala/3.jpeg"
    ]
  },
    {
    id: 45,
    title: "Ashirwada",
    date: "July 04, 2026",
    description: "'The Leo Club of the University of Sri Jayewardenepura commenced the new Leoistic year with Ashirwada, a blessing programme held at the Bellanwila Rajamaha Viharaya on 04th July 2026.",
    status: "Completed",
    images: [
      "/projects/45 Ashirwada/1.jpeg",
      "/projects/45 Ashirwada/2.jpeg",
      "/projects/45 Ashirwada/3.jpeg"
    ]
  },
  {
    id: 100,
    title: "Kadaimen Eha",
    date: "Continuous",
    description: "මනුෂ්‍යත්වයේ හඩ සුසර කරන්නට ශ්‍රී ජයවර්ධනපුර විශ්ව විද්‍යාලයීය දිස්ත්‍රික් 306 D7 ලියෝ සමාජයේ අප විසින් රත්මලාන බිහිරි විද්‍යාලයේ අපේම සොහොයුරු සොහොයුරියන් වෙනුවෙන් සිදු කරන 'කඩ ඉමෙන් එහා' ව්‍යාපෘතිය රත්මලාන බිහිරි විද්‍යාලයේ දී පැවැත්වේ. ",
    status: "ongoing",
    impact: "20+ children impacted",
    images: [
      "/projects/100 Kadaimen Eha/1.jpeg",
      "/projects/100 Kadaimen Eha/2.jpeg",
      "/projects/100 Kadaimen Eha/3.jpeg"
    ]
  },
  // add more projects here...
];